export default __webpack_public_path__ + "static/media/pexels-anna-shvets-4167544.212a049f.jpg";